// extracted by mini-css-extract-plugin
module.exports = {"image":"WhatsappFlowHeader_image__31S8c","header":"WhatsappFlowHeader_header__1X2_M"};